import { IFilter } from "../models/filters/filter";
import { IIndexFilter } from "../models/filters/indexFilter";
import _o2sService from "./_o2sServices";
import { IIndexForm } from "../models/forms/indexForm";
import { IIndexPDTO } from "../models/dtos/indexPDTO";
import { API_CENTRE } from "./config";
import { apiCallWithAuth } from "../helper/apiManager";
import { da } from "element-plus/es/locale/index.js";

export default class IndexServices extends _o2sService {
  protected static override mainUrl: string = API_CENTRE + "/api/v1/indexes";

  protected static override getUrlFilter<F extends IIndexFilter>(filter?: F): string {
    let url = super.getUrlFilter(filter as IFilter);
    if (filter != null) {
      if (filter.id != null)
        url += `&Id=${filter.id}`;
      if (filter.animalId != null)
        url += `&AnimalId=${filter.animalId}`;
      if (filter.origin != null)
        url += `&Origin=${filter.origin}`;
      if (filter.date != null)
        url += `&Date=${filter.date}`;
      if (filter.evaluationDate != null)
        url += `&EvaluationDate=${filter.evaluationDate}`;
    }
    return url;
  }

  protected static override toDTO(obj: IIndexForm): IIndexPDTO {
    const dto = super.toDTO(obj) as IIndexPDTO;

    return dto;
  }

  static async getLastIndexAnimal(idAnimal: number, typeIndex: string) {

    try {

      const { data } = await apiCallWithAuth(API_CENTRE + `/api/v1/indexes/${idAnimal}/${typeIndex}`, "get");

      return {
        error: false,
        data: data,
      };

    } catch (err) {
      return {
        error: true,
        data: err,
      };
    }

  }

  static async getIndexCountForAnimal(animalId: number) {
    try {
      const { data } = await apiCallWithAuth(API_CENTRE + `/api/v1/indexes/count/${animalId}`, "get");
      return {
        error: false,
        data: data
      }
    }
    catch (err) {
      return {
        error: true,
        data: err
      }
    }
  }
}
